/**
 * Build-time configuration. Every value has a production default so a bare
 * `vite build` produces the partners.finderlyfix.com build; the Pages project
 * (or a local `.env.local`) overrides them for internal and local stacks.
 */
function trimSlash(value: string): string {
  return value.replace(/\/+$/, '');
}

const env = import.meta.env as Record<string, string | undefined>;

/** The partner API host. `/partner/*` and `/l/:token` both live here. */
export const API_BASE = trimSlash(env.VITE_API_BASE || 'https://s.finderlyfix.com');

/** The widget loader partners embed; the branding preview loads the same file. */
export const WIDGET_SCRIPT_URL =
  env.VITE_WIDGET_SCRIPT_URL || 'https://cdn.finderlyfix.com/diagnosis-widget/v2/finderly-diagnosis-widget.js';

/**
 * contracts/partner-api.md §Versioning: date-based, sent on every request. The
 * server answers `400 UNSUPPORTED_API_VERSION` for anything it does not know,
 * so pinning it means a server that drops this version fails loudly instead of
 * silently changing shapes under the portal.
 */
export const PARTNER_API_VERSION = '2026-09-14';

/** The public host of the portal itself (for copy that names it). */
export const PORTAL_ORIGIN = typeof window === 'undefined' ? 'https://partners.finderlyfix.com' : window.location.origin;

/**
 * The Google OAuth web client id for "Continue with Google" (POST
 * /partner/auth/google). Empty — the default — hides the button, so a build
 * made before the OAuth client is configured behaves exactly as before. Must
 * equal the server's PARTNER_GOOGLE_CLIENT_ID (or, when that is unset, its
 * GOOGLE_WEB_CLIENT_ID). Public value, not a secret.
 */
export const GOOGLE_CLIENT_ID = (env.VITE_GOOGLE_CLIENT_ID || '').trim();
